import { render, staticRenderFns } from "./SetMenu.vue?vue&type=template&id=1e018ca4&scoped=true"
import script from "./SetMenu.vue?vue&type=script&lang=js"
export * from "./SetMenu.vue?vue&type=script&lang=js"
import style0 from "./SetMenu.vue?vue&type=style&index=0&id=1e018ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e018ca4",
  null
  
)

export default component.exports